import { FC } from 'react';
import { useIntl } from 'react-intl';
import { ImageBoxFuture } from './image-box-future';
const locationIcon = '/icons/shared/location-icon-blue.svg';

export const IconLocation: FC = () => {
  const intl = useIntl();
  return (
    <ImageBoxFuture
      img={locationIcon}
      title={intl.formatMessage({
        id: 'images.title.location',
      })}
      objectFit='contain'
      debug={false}
      sx={{
        width: '24px',
        height: '24px',
      }}
    />
  );
};

export default IconLocation;
